import { useParams } from "react-router";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrderById,
  sendToClient,
  setConfirmationTrigger,
  doInvoiceAction,
} from "../../../store/slices/OrderSlice/OrderSlice";
import { convertImageNameToWeb } from "../../../helpers/helperFunctions";
import {
  ORDER_ITEM_ADDON_TYPE,
  ORDER_ITEM_DESCRIPTION_TYPE,
} from "../../../helpers/const";
import ProgressBar from "../../atoms/ProgressBar/ProgressBar";
import { Link } from "react-router-dom";
import { getTrackMakesAndModels } from "../../../store/slices/ProductFinder/ProductFinderSlice";
import Button from "../../atoms/Button";
import EmailPopup from "../../atoms/EmailPopup/EmailPopup";

export default function OrderDetail() {
  const { id: order_num } = useParams();

  const [currentOrder, setCurrentOrder] = useState(order_num);

  const { loadedOrder: allOrders, openConfirmationTrigger } = useSelector(
    (state) => state.orders
  );
  const dispatch = useDispatch();

  const [showOrderConfirmationPopup, setShowOrderConfirmationPopup] =
    useState(false);

  useEffect(() => {
    setShowOrderConfirmationPopup(openConfirmationTrigger);
  }, [openConfirmationTrigger]);

  useEffect(() => {
    if (order_num) {
      dispatch(getOrderById({ order_num }));
    }
  }, [order_num, dispatch]);

  const fetchTrackMatches = (productCode) => {
    dispatch(getTrackMakesAndModels({ product_code: productCode }));
  };

  const handlePrintConfirmation = ({ emails }) => {
    let final_emails = [];
    for (let email of emails) {
      final_emails.push({ email: email });
    }
    if (emails && emails.length > 0) {
      dispatch(
        sendToClient({
          recipients: final_emails,
          customer_order_num: currentOrder,
        })
      );
    }
    setShowOrderConfirmationPopup(false);
    dispatch(setConfirmationTrigger(false));
  };

  const handleDownloadInvoice = (customerOrderNum) => {
    dispatch(
      doInvoiceAction({
        transactionNum: customerOrderNum,
        transactionNumType: "order",
        deliveryMethod: "pdf",
        emailAddress: "",
        useOverride: false,
        showPricing: true,
      })
    );
  };

  return (
    <>
      {/*
          This example requires updating your template:
  
          ```
          <html className="h-full bg-white">
          <body className="h-full">
          ```
        */}
      {allOrders && (
        <main className="relative lg:min-h-full bg-gradient-to-br bg-white/0">
          <div className="flex justify-around text-center">
            {allOrders.map((order, idx) => {
              return (
                <div
                  key={idx}
                  className={
                    "w-full bg-gradient-to-b from-white via-white to-blue-50 p-3 hover:from-blue-50 hover:via-blue-50 hover:to-blue-50" +
                    (currentOrder === order.customer_order_num
                      ? " border-b-4 border-[var(--primary-color)]"
                      : "")
                  }
                  onClick={() => {
                    setCurrentOrder(order.customer_order_num);
                  }}
                >
                  <div
                    className={
                      "text-sm font-medium text-gray-900 hover:text-[var(--secondary-color)] cursor-pointer"
                    }
                  >
                    {order.customer_order_num}
                  </div>
                </div>
              );
            })}
          </div>

          {allOrders.map((loadedOrder, idx) => {
            if (loadedOrder.customer_order_num !== currentOrder) return null;
            return (
              <div key={idx}>
                <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-24 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-4 lg:py-16 xl:gap-x-24">
                  <div className="lg:col-start-0">
                    <h1 className="text-sm font-medium text-[var(--primary-color)]">
                      {" "}
                      Order Number {loadedOrder.customer_order_num} (PO{" "}
                      {loadedOrder.customer_po && loadedOrder.customer_po})
                    </h1>
                    <ul className="mt-6 divide-y divide-gray-200 border-gray-200 text-sm font-medium text-gray-500">
                      {[...loadedOrder.line_items]
                        .sort((a, b) => a.item.id - b.item.id)
                        .map((group) => {
                          // For description and addon items, only show the description
                          if (
                            [
                              ORDER_ITEM_DESCRIPTION_TYPE,
                              ORDER_ITEM_ADDON_TYPE,
                            ].includes(group.item.item_type)
                          ) {
                            return (
                              <li key={group.item.id} className="py-4">
                                <div className="text-gray-700">
                                  ** <i>{group.item.description}</i>
                                </div>
                              </li>
                            );
                          }

                          return (
                            <li
                              key={group.item.id}
                              className="flex flex-col space-y-4 py-6"
                            >
                              <div className="flex space-x-6">
                                <img
                                  alt={group.item.image_num}
                                  src={
                                    process.env.REACT_APP_IMAGE_URL +
                                    convertImageNameToWeb(group.item.image_name)
                                  }
                                  className="h-32 w-32 flex-none rounded-md bg-gray-100 object-contain p-2"
                                />

                                <div className="flex-auto space-y-1">
                                  <h3 className="text-gray-900">
                                    <p>{group.item.description}</p>
                                  </h3>
                                  <p>
                                    {group.item.item_price
                                      ? `$${group.item.item_price}`
                                      : "-"}{" "}
                                    x {group.item.qty_shipped}
                                  </p>
                                  <p>{group.item.xref_code}</p>
                                  <p>{group.item.product_code}</p>
                                  {["16", "17"].includes(
                                    group.item.product_code.substring(0, 2)
                                  ) && (
                                    <p
                                      onClick={() =>
                                        fetchTrackMatches(
                                          group.item.product_code
                                        )
                                      }
                                      className="text-[var(--primary-color)] hover:cursor-pointer hover:text-[var(--secondary-color)]"
                                    >
                                      What does this fit?
                                    </p>
                                  )}
                                </div>

                                <p className="flex-none font-medium text-gray-900">
                                  {group.item.price
                                    ? `$${group.item.price}`
                                    : "-"}
                                </p>
                              </div>

                              {group.subitems?.length > 0 && (
                                <ul className="pl-10 space-y-4">
                                  {group.subitems.map((subitem) => (
                                    <li
                                      key={subitem.id}
                                      className="flex space-x-6"
                                    >
                                      <div className="flex-auto space-y-1">
                                        <h3 className="text-gray-900">
                                          <i>** {subitem.description}</i>
                                        </h3>
                                      </div>

                                      <p className="flex-none font-medium text-gray-900">
                                        {subitem.price
                                          ? `$${subitem.price}`
                                          : ""}
                                      </p>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                  <div className="lg:col-start-2">
                    <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                      Thanks for ordering
                    </p>
                    <ProgressBar
                      className="border-b pb-4 mb-4 mt-5"
                      status={loadedOrder.status}
                    />

                    <div className="lg:flex md:flex">
                      <div>
                        <dt className="font-medium text-gray-900">
                          Shipping Address
                        </dt>
                        <dd className="mt-2">
                          <address className="not-italic">
                            <span className="block">
                              {loadedOrder.shipping_address.shipping_name}
                            </span>
                            <span className="block">
                              {loadedOrder.shipping_address.street}
                            </span>
                            <span className="block">
                              {loadedOrder.shipping_address.route}
                            </span>
                            <span className="block">
                              {loadedOrder.shipping_address.locale}
                            </span>
                          </address>
                        </dd>
                      </div>
                      <div className=" mt-8 md:mt-0 lg:ml-32 md:ml-32">
                        <dt className="font-medium text-gray-900">
                          Billing Address
                        </dt>
                        <dd className="mt-2">
                          <address className="not-italic">
                            <span className="block">
                              {loadedOrder.billing_address.billing_name}
                            </span>
                            <span className="block">
                              {loadedOrder.billing_address.street}
                            </span>
                            <span className="block">
                              {loadedOrder.billing_address.route}
                            </span>
                            <span className="block">
                              {loadedOrder.billing_address.locale}
                            </span>
                          </address>
                        </dd>
                      </div>
                    </div>
                    <div className="mt-4 flex">
                      <div>
                        <dl className="flex gap-4 text-sm font-medium items-center">
                          <dt>Freight Line:</dt>
                          <dd className="text-gray-900 font-normal">
                            {loadedOrder.freight_line}
                          </dd>
                        </dl>
                        <dl className="flex gap-4 text-sm font-medium items-center">
                          <dt className="text-gray-900">Tracking number:</dt>
                          <dd className="text-[var(--primary-color)] flex items-center gap-2">
                            {loadedOrder.tracking_number?.trim()
                              ? loadedOrder.tracking_number
                              : "Not Available"}
                            {loadedOrder.tracking_url && (
                                <a
                                  href={loadedOrder.tracking_url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="inline-flex items-center text-blue-600 hover:text-blue-800 transition-colors"
                                  title="Track Package"
                                >
                                  <svg
                                    className="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                    />
                                  </svg>
                                </a>
                              )}
                          </dd>
                        </dl>
                      </div>
                      {loadedOrder.third_party_billing.name && (
                        <div className=" mt-8 md:mt-0 lg:ml-32 md:ml-32">
                          <dt className="font-medium text-gray-900">
                            Freight Billing Address
                          </dt>
                          <dd className="mt-2">
                            <address className="not-italic">
                              <span className="block">
                                {loadedOrder.third_party_billing.name}
                              </span>
                              <span className="block">
                                {loadedOrder.third_party_billing.addr1}
                              </span>
                              <span className="block">
                                {loadedOrder.third_party_billing.addr2}
                              </span>
                              <span className="block">
                                {loadedOrder.third_party_billing.city +
                                  ", " +
                                  loadedOrder.third_party_billing.state +
                                  " " +
                                  loadedOrder.third_party_billing.zip_code}
                              </span>
                            </address>
                          </dd>
                        </div>
                      )}
                    </div>

                    {loadedOrder.comments?.length > 0 && (
                      <div className="mt-4">
                        <dt className="font-medium text-gray-900">Comments</dt>
                        <dd className="mt-2 space-y-1 text-sm text-gray-700">
                          {loadedOrder.comments.map((comment, index) => (
                            <p key={index}>{comment}</p>
                          ))}
                        </dd>
                      </div>
                    )}

                    <dl className="space-y-3 mt-4 border-t border-gray-200 pt-2 text-sm font-medium text-gray-500">
                      <div className="flex justify-between">
                        <dt>Subtotal</dt>
                        <dd className="text-gray-900">
                          {loadedOrder.total
                            ? `$${loadedOrder.subtotal?.toFixed(2)}`
                            : "-"}
                        </dd>
                      </div>

                      <div className="flex justify-between">
                        <dt>Shipping and Handling</dt>
                        <dd className="text-gray-900">
                          {loadedOrder.shipping_charge
                            ? `$${loadedOrder.shipping_charge?.toFixed(2)}`
                            : "-"}
                        </dd>
                      </div>
                      <div className="flex justify-between">
                        <dt>Tariff</dt>
                        <dd className="text-gray-900">
                          {loadedOrder.tariff_amount
                            ? `$${loadedOrder.tariff_amount?.toFixed(2)}`
                            : "-"}
                        </dd>
                      </div>
                      <div className="flex justify-between">
                        <dt>Surcharges</dt>
                        <dd className="text-gray-900">
                          {loadedOrder.surcharge
                            ? `$${loadedOrder.surcharge?.toFixed(2)}`
                            : "-"}
                        </dd>
                      </div>

                      <div className="flex justify-between">
                        <dt>Taxes</dt>
                        <dd className="text-gray-900">
                          {loadedOrder.tax
                            ? `$${loadedOrder.tax?.toFixed(2)}`
                            : "-"}
                        </dd>
                      </div>

                      <div className="flex items-center justify-between border-t border-gray-200 pt-6 text-gray-900">
                        <dt className="text-base">Total</dt>
                        <dd className="text-base">
                          ${loadedOrder.total?.toFixed(2)}
                        </dd>
                      </div>
                    </dl>

                    <div className="mt-6 border-t border-gray-200 py-6 text-right">
                      <div className="flex flex-col sm:flex-row gap-4 justify-end items-end">
                        <Button
                          textContent="Send Confirmation"
                          type="positive"
                          onClick={() => setShowOrderConfirmationPopup(true)}
                        />

                        {loadedOrder.customer_invoice_num &&
                        loadedOrder.customer_invoice_num !== "0" ? (
                          <Button
                            textContent="Download Invoice"
                            type="positive"
                            onClick={() =>
                              handleDownloadInvoice(
                                loadedOrder.customer_order_num
                              )
                            }
                          />
                        ) : (
                          <span className="text-sm text-gray-500 self-center">
                            Invoice not ready
                          </span>
                        )}
                      </div>

                      <Link
                        to="/"
                        className="inline-block mt-4 text-sm font-medium text-[var(--primary-color)] hover:text-[var(--secondary-color)]"
                      >
                        Back to Home
                        <span aria-hidden="true"> &rarr;</span>
                      </Link>
                    </div>
                  </div>
                </div>
                <EmailPopup
                  HeaderText="Order Confirmation"
                  BodyText="Please enter any email addresses you would like to send the order confirmation to."
                  cancelFunction={() => setShowOrderConfirmationPopup(false)}
                  dropDownEmails={
                    loadedOrder ? loadedOrder.contact?.emails : []
                  }
                  SubmitFunction={handlePrintConfirmation}
                  show={showOrderConfirmationPopup}
                />
              </div>
            );
          })}
        </main>
      )}
    </>
  );
}
